import axios from "axios";

export function apiGetOrgunits(instance, queryParams) {
  return axios
    .get(
      process.env.REACT_APP_URL_EXPRESS + "api/orgunits" + (queryParams ? "?" + queryParams : ""),
      {
        headers: {
          instance: instance,
        },
      }
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiGetOrgunit(instance, id) {
  return axios
    .get(process.env.REACT_APP_URL_EXPRESS + "api/orgunits/" + id, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiSaveOrgunit(instance, formData) {
  return axios
    .post(process.env.REACT_APP_URL_EXPRESS + "api/orgunits", formData, {
      headers: {
        instance: instance,
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateOrgunit(idOrgunit, formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/orgunits/" + idOrgunit, formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiDeleteOrgunit(idOrgunit) {
  return axios
    .delete(process.env.REACT_APP_URL_EXPRESS + "api/orgunits/" + idOrgunit)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}

export function apiUpdateOrgunits(formData) {
  return axios
    .put(process.env.REACT_APP_URL_EXPRESS + "api/orgunits/multiple", formData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
}
